import { GuideSection } from '@/components/guides/GuideSection';
import { GuideSteps, GuideStep } from '@/components/guides/GuideSteps';
import { GuideCallout } from '@/components/guides/GuideCallout';

export function ConnectToInterviewSection() {
  return (
    <GuideSection
      id="connect-to-interview"
      eyebrow="Step 3"
      title="Connect to your interview"
      description="Once your team schedules a session, NeuraX detects it automatically. You don't need to paste anything else — just open the app."
    >
      <GuideSteps>
        <GuideStep number={1} title="Open NeuraX 10 minutes before the interview">
          <p>
            Launch the app well before your interview starts. You'll see a pending session card with
            the company name, position, and scheduled time — e.g.,
            <em> "Interview with Google · SDE II · in 8 min."</em>
          </p>
        </GuideStep>

        <GuideStep number={2} title="Check the mic source">
          <p>
            On the same screen, confirm the correct microphone is selected. If you're on Zoom,
            Google Meet, or Teams, use the same mic in both apps so NeuraX hears what the
            interviewer hears.
          </p>
        </GuideStep>

        <GuideStep number={3} title="Start the session when the interview begins">
          <p>
            When your interviewer joins the call, click <strong>Start session</strong> in NeuraX.
            The status flips to <em>Live</em> and the coaching pane opens. Your team sees the
            session flip to "Live" on their end too.
          </p>
        </GuideStep>

        <GuideStep number={4} title="Position the NeuraX window">
          <p>
            Drag NeuraX to a corner of your screen where you can glance at it without looking
            obviously off-camera. On a laptop, the top-right corner (below your webcam) works well.
            If you have a second monitor, put NeuraX on the other screen.
          </p>
        </GuideStep>

        <GuideStep number={5} title="End the session when the interview finishes">
          <p>
            After the call ends, click <strong>End session</strong> in NeuraX. The app syncs the
            transcript and coaching logs back to your team's portal within about a minute. If you
            forget to click End, NeuraX will auto-end after ~5 minutes of silence — the transcript
            still syncs.
          </p>
        </GuideStep>
      </GuideSteps>

      <GuideCallout variant="info" title="Interview platforms">
        <p>
          NeuraX works with every virtual interview tool — Zoom, Google Meet, Microsoft Teams,
          Amazon Chime, BlueJeans, even plain phone calls through Bluetooth. It listens to your
          system audio, not to a specific app.
        </p>
      </GuideCallout>

      <GuideCallout variant="warning" title="In-person interviews">
        <p>
          If you're interviewing in person with only your laptop mic, NeuraX will still work but
          transcript quality drops because the interviewer is several feet away. A small USB
          omnidirectional mic placed between you both fixes this.
        </p>
      </GuideCallout>
    </GuideSection>
  );
}
